import {store} from "../app/store";
import {applicationSelector, closeConfirm, openConfirm} from "./application";

//Пришлось вынести в отдельный модуль, т.к иначе из-за импорта store получаются циклические ссылки
//TODO: разобраться с динамическим импортом
export const confirm = (message, titleStr, okTitle, cancelTitle, isRaiseErrorWhenCancel = true) => {
  return (dispatch, getState) => {
    dispatch(openConfirm({message, titleStr, okTitle, cancelTitle}));
    return new Promise((res, rej) => {
      let unsubscribe;
      const handleCloseDlg = () => {
        const state = getState();
        let {confirm} = applicationSelector(state);
        if (confirm.resolved) {
          //dispatch(closeConfirm());
          unsubscribe();
          res();
        }
        if (confirm.rejected) {
          //dispatch(closeConfirm());
          unsubscribe();
          if (isRaiseErrorWhenCancel) rej();
        }
      };
      unsubscribe = store.subscribe(handleCloseDlg);
    })
  }
};
